import { sanitizeBindable, sanitizeBoolean, sanitizeBoundValue, sanitizeFormatSpec, sanitizeFormattableBindable, sanitizePositiveInteger, sanitizeString } from './helpers';
function sanitizeSlots(raw) {
  if (!Array.isArray(raw)) return undefined;
  const slots = raw.filter(s => typeof s === 'object' && s !== null).map(s => {
    const value = sanitizeString(s.value);
    const label = sanitizeFormattableBindable(s.label, sanitizeString);
    if (value === undefined || label === undefined) return undefined;
    const group = sanitizeString(s.group);
    return group !== undefined ? {
      value,
      label,
      group
    } : {
      value,
      label
    };
  }).filter(s => s !== undefined);
  return slots.length > 0 ? slots : undefined;
}
export function sanitizeSlotList(el) {
  const value = sanitizeBoundValue(el.value);
  if (!value) return null;
  const slots = sanitizeBindable(el.slots, sanitizeSlots);
  if (!slots) return null;
  return {
    type: 'SlotList',
    value,
    slots,
    group: sanitizeBindable(el.group, sanitizeString),
    maxVisibleSlots: sanitizeBindable(el.maxVisibleSlots, sanitizePositiveInteger),
    slotFormat: sanitizeFormatSpec(el.slotFormat),
    required: sanitizeBindable(el.required, sanitizeBoolean),
    disabled: sanitizeBindable(el.disabled, sanitizeBoolean)
  };
}